var next = __webpack_require__.x
__webpack_require__.x = function() {
  return __webpack_require__.e("webpack_sharing_provide_default_lingui_core-webpack_sharing_provide_default_lingui_react-webp-ca63c4").then(next);
}